import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import get from 'lodash.get'
import { ICON_NAMES } from '../../../../../constants'
import Icon from '../../../../atoms/Icon'

const useStyles = makeStyles(theme => ({
  typeChip: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.layout.gap.g10,
    fontWeight: theme.typography.weights.bold,
    border: 'var(--border-neutral-thin)',
    boxShadow: theme.layout.shadow.light,
    borderRadius: 'var(--border-radius-lg)',
    paddingTop: theme.layout.padding.p10,
    paddingRight: theme.layout.padding.p20,
    paddingBottom: theme.layout.padding.p10,
    paddingLeft: theme.layout.padding.p15
  },
  typeIcon: {
    fill: 'var(--color-primary-500)',
    stroke: 'var(--color-primary-500)',
    borderRadius: 'var(--border-radius-round)',
    boxShadow: theme.layout.shadow.insetNormal
  }
}))

function TypeChip ({ entryType: _entryType, iconSize = 20, className, style, colorAccessor = 'color', nameAccessor = 'entryTypeName', iconAccessor = null }) {
  const classes = useStyles()

  const entryType = useMemo(() => {
    if (!_entryType) return null
    return {
      color: get(_entryType, colorAccessor),
      name: get(_entryType, nameAccessor) ?? '',
      icon: !iconAccessor ? ICON_NAMES.circle : get(_entryType, iconAccessor)
    }
  }, [_entryType, colorAccessor, nameAccessor, iconAccessor])

  if (!entryType || !entryType?.name?.length) return null

  return (
    <div className={clsx(classes.typeChip, className)} style={style}>
      <Icon
        additionalClasses={classes.typeIcon}
        name={entryType.icon}
        customSize={iconSize}
        style={{
          fill: entryType.color,
          stroke: entryType.color
        }}
      />

      {entryType.name}
    </div>
  )
}

TypeChip.propTypes = {
  entryType: PropTypes.object,
  iconSize: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  colorAccessor: PropTypes.string,
  nameAccessor: PropTypes.string,
  iconAccessor: PropTypes.string
}

export default TypeChip
